import React, { HTMLAttributes } from 'react';
import { makeStyles } from 'tss-react/mui';
import { notNullOrEmpty } from '../../utils/common';
import { ClgCtaLink, Cta, CtaLink, CtaLinkParams } from '../cta';

const useStyles = makeStyles({ name: 'CtaPanel' })((theme) => ({
	root: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 16,
		justifyContent: 'center'
	},
	cta: {

	}
}));

export type CtaInfo = {
	link: CtaLink;
	label: string;
	type: string;
	target?: '_blank';
}

export type CtaPanelProps = HTMLAttributes<HTMLDivElement> & {
	cta1?: CtaInfo;
	cta2?: CtaInfo;
	bid: string;
	culture: string;
	dealer?: string;
	params?: CtaLinkParams;
	onCtaClick?: (href: string, label: string, type: string) => void;
	reverse?: boolean;
	primaryIfSingle?: boolean;
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
};

export const CtaPanel: React.FC<CtaPanelProps> = (props) => {
	const { cta1, cta2, classes, className, bid, culture, dealer, params, onCtaClick, reverse, primaryIfSingle, ...other } = props;

	let { classes: styles, cx } = useStyles(undefined, { props: { classes } });

	const checkClgCtaLink = (link: ClgCtaLink) =>
		notNullOrEmpty(link.clgEndpoint) && notNullOrEmpty(link.tool);

	const checkCtaLink = (cta: CtaInfo) =>
		cta?.link &&
		(typeof (cta.link) === 'string'
			? cta.link.length
			: checkClgCtaLink(cta.link));

	const hasCta1 = checkCtaLink(cta1);
	const hasCta2 = checkCtaLink(cta2);
	const hasCta = hasCta1 || hasCta2;

	if (!hasCta)
		return null;

	const CommonProps = { bid, culture, dealer, params, className: styles.cta, onClick: onCtaClick };

	const colorCta1 = 'primary';
	const colorCta2 = !primaryIfSingle || hasCta1 ? 'secondary' : 'primary';

	let ctas = [
		hasCta1 && <Cta key={'cta1'} data-test='cta1' {...CommonProps} {...cta1} color={colorCta1} />,
		hasCta2 && <Cta key={'cta2'} data-test='cta2' {...CommonProps} {...cta2} color={colorCta2} />
	];

	if (reverse)
		ctas = ctas.reverse();

	return (
		<div data-test='cta-container' className={cx(styles.root, className)} {...other}>
			{ctas}
		</div>
	);
};
